import { values } from 'ramda';
import { ofType } from 'redux-observable';
import { Observable, of } from 'rxjs';
import { mergeMap, takeUntil, withLatestFrom } from 'rxjs/operators';
import { Weddings } from '@bridebook/models';
import { SentryMinimal } from '@bridebook/toolbox/src/sentry';
import { Action, IEpicDeps } from '@bridebook/web/lib/types';
import { WeddingWebsiteActionTypes } from '@bridebook/web/lib/wedding-website/action-types';
import { convertOldEventsToNewEvents } from '@bridebook/web/lib/wedding-website/hooks/query/events/date-time-migration';
import { updateWeddingEventsCache } from '@bridebook/web/lib/wedding-website/hooks/query/events/use-events';
import { sortEventsByDate } from '@bridebook/web/lib/events/sort-events';
import { onFirebaseWeddingEvents } from '@bridebook/web/lib/events/actions';

export const initWeddingEventsListener = (
  action$: Observable<Action>,
  { state$, queryClient }: IEpicDeps,
) =>
  action$.pipe(
    ofType(WeddingWebsiteActionTypes.INIT_LISTENER),
    withLatestFrom(state$),
    mergeMap(([_, state]) => {
      const weddingId = state.weddings.profile.id;

      const events$ = Weddings._.getById(weddingId).Events.query().observe();

      return events$.pipe(
        mergeMap((eventsById) => {
          try {
            const eventsList = sortEventsByDate(convertOldEventsToNewEvents(values(eventsById)));
            if (eventsById) {
              updateWeddingEventsCache(queryClient, weddingId, eventsList);
              return of(onFirebaseWeddingEvents(eventsList));
            }
          } catch (e) {
            SentryMinimal().captureMessage('Failed to refresh wedding events cache', e);
          }
          return of();
        }),
        takeUntil(action$.pipe(ofType(WeddingWebsiteActionTypes.STOP_LISTENER))),
      );
    }),
  );
